var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4683 27.5815C14.7751 29.8884 16.6618 32.3717 18.0806 34.856C18.9516 36.3813 21.148 36.3813 22.0191 34.856C23.4378 32.3717 25.3244 29.8885 27.6313 27.5815C29.9383 25.2746 32.4215 23.388 34.9058 21.9693C36.4311 21.0982 36.4311 18.9018 34.9058 18.0307C32.4215 16.612 29.9383 14.7254 27.6313 12.4185C25.3244 10.1115 23.4378 7.62826 22.0191 5.144C21.148 3.61867 18.9516 3.61867 18.0806 5.144C16.6618 7.62826 14.7752 10.1115 12.4683 12.4185C10.1613 14.7254 7.67806 16.612 5.1938 18.0307C3.66847 18.9018 3.66847 21.0982 5.1938 21.9693C7.67806 23.388 10.1614 25.2746 12.4683 27.5815Z",
    fill: "#FBCDD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32739 19.9995C9.32739 23.262 8.9055 26.352 8.15205 29.1118C7.68944 30.8063 9.2425 32.3593 10.937 31.8967C13.6968 31.1433 16.7868 30.7214 20.0493 30.7214C23.3117 30.7214 26.4017 31.1433 29.1615 31.8967C30.8561 32.3593 32.4091 30.8063 31.9465 29.1118C31.193 26.352 30.7711 23.2619 30.7711 19.9995C30.7711 16.7371 31.193 13.647 31.9465 10.8872C32.4091 9.19269 30.856 7.63969 29.1615 8.10231C26.4018 8.85575 23.3118 9.27759 20.0493 9.27759C16.7868 9.27759 13.6968 8.85569 10.9371 8.10225C9.2425 7.63963 7.6895 9.19269 8.15212 10.8872C8.90556 13.647 9.32739 16.737 9.32739 19.9995Z",
    fill: "#DC7296"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.8342 24.9533L15.0943 21.2133C14.423 20.5421 14.423 19.4537 15.0943 18.7824L18.8342 15.0425C19.5054 14.3713 20.5938 14.3713 21.2651 15.0425L25.005 18.7824C25.6763 19.4537 25.6763 20.542 25.005 21.2133L21.2651 24.9533C20.5938 25.6246 19.5054 25.6246 18.8342 24.9533Z",
    fill: "#FEEFF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.4a2a2bbb005f86b7b30393f01fe5af75.svg";
export { ForwardRef as ReactComponent };